import { AttendeeEvents } from 'src/redesign/features/AttendeeEvents';
import { AttendeeEventsSidebar } from 'src/redesign/features/AttendeeEventsSidebar';

export const AttendeeEventsPage = () => {
  return (
    <div>
      <AttendeeEvents />
      <AttendeeEventsSidebar />
    </div>
  );
};
